import { render, staticRenderFns } from "./profileButtonBarBot.vue?vue&type=template&id=0175bd53&"
import script from "./profileButtonBarBot.vue?vue&type=script&lang=js&"
export * from "./profileButtonBarBot.vue?vue&type=script&lang=js&"
import style0 from "./profileButtonBarBot.vue?vue&type=style&index=0&id=0175bd53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports